export default __webpack_public_path__ + "static/media/Levan Katsadze_pic_2026-01_e-small.07bb7689.jpg";